import { defineMessages } from 'react-intl';

import { lightBackgroundPaletteTooltipMessages } from './lightBackgroundPaletteTooltipMessages';
import { lightChartsColorPaletteTooltipMessages } from './lightChartsColorPaletteTooltipMessages';
import { lightTextPaletteTooltipMessages } from './lightTextPaletteTooltipMessages';

const darkModeTextPaletteOverrides = defineMessages({
	'#FFFFFF': {
		id: 'fabric.theme.dark-gray',
		defaultMessage: 'Dark gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor text color picker in dark mode when the user hovers over the dark gray color option.',
	},
});

export const darkTextPaletteTooltipMessages: {
	'#FFFFFF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#B3D4FF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#B3F5FF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#ABF5D1': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFF0B3': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFBDAD': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#EAE6FF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#97A0AF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#4C9AFF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#00B8D9': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#36B37E': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFC400': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FF5630': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FF991F': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#6554C0': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#0747A6': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#008DA6': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#006644': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#BF2600': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#403294': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#172B4D': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = {
	...lightTextPaletteTooltipMessages,
	...darkModeTextPaletteOverrides,
};

export const textPaletteTooltipMessages: {
	light: {
		'#FFFFFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3D4FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3F5FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#ABF5D1': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFF0B3': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFBDAD': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#EAE6FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#97A0AF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#4C9AFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#00B8D9': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#36B37E': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFC400': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF5630': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF991F': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#6554C0': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#0747A6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#008DA6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#006644': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#BF2600': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#403294': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#172B4D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
	dark: {
		'#FFFFFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3D4FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3F5FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#ABF5D1': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFF0B3': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFBDAD': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#EAE6FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#97A0AF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#4C9AFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#00B8D9': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#36B37E': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFC400': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF5630': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF991F': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#6554C0': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#0747A6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#008DA6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#006644': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#BF2600': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#403294': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#172B4D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
} = {
	// eslint-disable-next-line @atlaskit/editor/no-re-export
	light: lightTextPaletteTooltipMessages,
	dark: darkTextPaletteTooltipMessages,
};

const darkModeBackgroundPaletteOverrides = defineMessages({
	'#FFFFFF': {
		id: 'fabric.theme.subtle-gray',
		defaultMessage: 'Subtle gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker in dark mode when the user hovers over the subtle gray color option.',
	},
	'#B3BAC5': {
		id: 'fabric.theme.bold-gray',
		defaultMessage: 'Bold gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker in dark mode when the user hovers over the bold gray color option.',
	},
});

export const darkBackgroundPaletteTooltipMessages: {
	'#FFFFFF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#B3BAC5': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#DEEBFF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#B3D4FF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#4C9AFF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#E6FCFF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#B3F5FF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#79E2F2': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#E3FCEF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#ABF5D1': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#57D9A3': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFFAE6': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFF0B3': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFC400': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFEBE6': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FFBDAD': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#FF8F73': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#EAE6FF': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#C0B6F2': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#998DD9': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'#F4F5F7': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = {
	...lightBackgroundPaletteTooltipMessages,
	...darkModeBackgroundPaletteOverrides,
};

export const backgroundPaletteTooltipMessages: {
	light: {
		'#DEEBFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3D4FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#4C9AFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#E6FCFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3F5FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#79E2F2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#E3FCEF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#ABF5D1': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#57D9A3': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFFAE6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFF0B3': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFC400': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFEBE6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFBDAD': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF8F73': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#EAE6FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#C0B6F2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#998DD9': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFFFFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#F4F5F7': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3BAC5': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
	dark: {
		'#FFFFFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3BAC5': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#DEEBFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3D4FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#4C9AFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#E6FCFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B3F5FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#79E2F2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#E3FCEF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#ABF5D1': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#57D9A3': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFFAE6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFF0B3': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFC400': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFEBE6': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFBDAD': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF8F73': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#EAE6FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#C0B6F2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#998DD9': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#F4F5F7': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
} = {
	// eslint-disable-next-line @atlaskit/editor/no-re-export
	light: lightBackgroundPaletteTooltipMessages,
	dark: darkBackgroundPaletteTooltipMessages,
};

const darkChartsColorPaletteTooltipMessages = {
	...lightChartsColorPaletteTooltipMessages,
};

export const chartsColorPaletteTooltipMessages: {
	light: {
		// Blue color
		'#7AB2FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#247FFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#0055CC': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#003884': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Teal color
		'#60C6D2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#1D9AAA': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#1D7F8C': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#206B74': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Green color
		'#6BE1B0': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#23A971': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#177D52': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#055C3F': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Yellow color
		'#FFDB57': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFBE33': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF9D00': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#946104': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Red color
		'#FF8F73': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FC552C': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#D32D03': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#A32000': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Orange color
		'#FAA53D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#D97008': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B65C02': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#974F0C': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Magenta color
		'#E774BB': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#DA62AC': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#CD519D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#943D73': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Purple color
		'#B5A7FB': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#8B77EE': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#5A43D0': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#44368B': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Gray color
		'#8993A5': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#8590A2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#758195': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#44546F': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
	dark: {
		// Blue color
		'#7AB2FF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#247FFF': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#0055CC': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#003884': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Teal color
		'#60C6D2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#1D9AAA': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#1D7F8C': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#206B74': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Green color
		'#6BE1B0': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#23A971': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#177D52': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#055C3F': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Yellow color
		'#FFDB57': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FFBE33': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FF9D00': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#946104': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Red color
		'#FF8F73': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#FC552C': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#D32D03': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#A32000': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Orange color
		'#FAA53D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#D97008': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#B65C02': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#974F0C': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Magenta color
		'#E774BB': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#DA62AC': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#CD519D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#943D73': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Purple color
		'#B5A7FB': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#8B77EE': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#5A43D0': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#44368B': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		// Gray color
		'#8993A5': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#8590A2': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#758195': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#44546F': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
} = {
	// eslint-disable-next-line @atlaskit/editor/no-re-export
	light: lightChartsColorPaletteTooltipMessages,
	dark: darkChartsColorPaletteTooltipMessages,
};

const lightBorderPaletteTooltipMessages = defineMessages({
	'#091E4224': {
		id: 'fabric.theme.subtle-gray',
		defaultMessage: 'Subtle gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor border color picker when the user hovers over the subtle gray color option.',
	},
	'#758195': {
		id: 'fabric.theme.gray',
		defaultMessage: 'Gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor border color picker when the user hovers over the gray color option.',
	},
	'#172B4D': {
		id: 'fabric.theme.bold-gray',
		defaultMessage: 'Bold gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor border color picker when the user hovers over the bold gray color option.',
	},
});

const darkBorderPaletteTooltipMessages = {
	...lightBorderPaletteTooltipMessages,
};

export const borderPaletteTooltipMessages: {
	light: {
		'#091E4224': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#758195': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#172B4D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
	dark: {
		'#091E4224': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#758195': {
			id: string;
			defaultMessage: string;
			description: string;
		};
		'#172B4D': {
			id: string;
			defaultMessage: string;
			description: string;
		};
	};
} = {
	light: lightBorderPaletteTooltipMessages,
	dark: darkBorderPaletteTooltipMessages,
};
// eslint-disable-next-line @atlaskit/editor/no-re-export
export { lightTextPaletteTooltipMessages } from './lightTextPaletteTooltipMessages';
// eslint-disable-next-line @atlaskit/editor/no-re-export
export { lightBackgroundPaletteTooltipMessages } from './lightBackgroundPaletteTooltipMessages';
// eslint-disable-next-line @atlaskit/editor/no-re-export
export { lightChartsColorPaletteTooltipMessages } from './lightChartsColorPaletteTooltipMessages';
